const MSK = 'Europe/Moscow';

function toDate(value: string | number | Date | null | undefined): Date | null {
    if (value === null || value === undefined || value === '') return null;
    const d = value instanceof Date ? value : new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
}

/** «05.11.2026, 14:30» по Москве — интервалы, часы клубов и отчёты у нас в МСК. */
export function formatMsk(value: string | number | Date | null | undefined): string {
    const d = toDate(value);
    if (!d) return '—';
    return d.toLocaleString('ru-RU', {
        timeZone: MSK,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

export function formatDate(value: string | number | Date | null | undefined): string {
    const d = toDate(value);
    if (!d) return '—';
    return d.toLocaleDateString('ru-RU', { timeZone: MSK });
}

export function formatDuration(ms: number): string {
    if (!Number.isFinite(ms) || ms < 0) return '—';
    const minutes = Math.floor(ms / 60000);
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor((minutes % 1440) / 60);
    const mins = minutes % 60;
    if (days > 0) return `${days} д ${hours} ч`;
    if (hours > 0) return `${hours} ч ${mins} мин`;
    if (mins > 0) return `${mins} мин`;
    return '< 1 мин';
}

export function timeAgo(value: string | number | Date | null | undefined, now = Date.now()): string {
    const d = toDate(value);
    if (!d) return '—';
    const diff = now - d.getTime();
    if (diff < 0) return 'только что';
    const sec = Math.floor(diff / 1000);
    if (sec < 60) return `${sec} сек назад`;
    const min = Math.floor(sec / 60);
    if (min < 60) return `${min} мин назад`;
    const h = Math.floor(min / 60);
    if (h < 24) return `${h} ч назад`;
    return `${Math.floor(h / 24)} д назад`;
}

export function formatRub(value: number | string | null | undefined): string {
    const n = Number(value);
    if (!Number.isFinite(n)) return '—';
    return `${n.toLocaleString('ru-RU', { maximumFractionDigits: 2 })} ₽`;
}

/** ISO → значение для <input type="datetime-local"> в часовом поясе устройства. */
export function isoToLocalInput(iso: string | null | undefined): string {
    const d = toDate(iso);
    if (!d) return '';
    const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
    return local.toISOString().slice(0, 16);
}

/** datetime-local (время устройства, без зоны) → ISO в UTC, иначе бэк запишет его как UTC. */
export function localInputToIso(value: string): string | null {
    if (!value) return null;
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
